import React, { useEffect, useState, useRef } from 'react'
import {
  Home,
  Power,
  RefreshCw,
  Server,
  Settings,
  User,
  Users,
  BookOpen,
  Tool,
  CheckCircle,
  Folder,
  Sun,
  Grid
} from 'react-feather'
import { Link, NavLink, useLocation, matchPath } from 'react-router-dom'
import { InstructorProfileBg, User15 } from '../../imagepath'
import StickyBox from 'react-sticky-box'
import { signOut } from '../../../lib/auth'
import { useNavigate } from 'react-router-dom'

// eslint-disable-next-line react/prop-types
export default function AdminSidebar({
  activeMenu,
  mobileMenu,
  setMobileMenu
}) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const sidebarRef = useRef(null)

  // console.log('path', pathname.slice(0, pathname.lastIndexOf('/')))

  const setNavlinkClasses = (paths) => {
    paths.map((path) => pathname.includes(path)) //matchPath(path, pathname))
      ? 'nav-item active'
      : 'nav-item'
  }

  //isActive={() => ['/events', '/myevents'].includes(pathname)} >
  let isActive = (paths) => paths.includes(pathname)

  //console.log("path",pathname.includes(path));
  //https://dev.to/kiranmantha/how-to-set-active-class-on-navlink-for-multiple-react-routes-3n9i
  /*
if(pathname.includes(path))
  return "nav-item active";
else  return "nav-item";

})
*/

  //console.log("pathname",isActive(["/admin/admin-studentdetail","anvv","saamdlam"]));

  const handleSignOut = async (e) => {
    const error = await signOut()

    navigate('/login')
  }
  const hideMobileMenu = () => {
    document.body.classList.remove('menu-opened')
    setMobileMenu(false)
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        document.body.classList.remove('menu-opened')
        setMobileMenu(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [setMobileMenu])

  return (
    <div className='theiaStickySidebar adminSidebar' ref={sidebarRef}>
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className='sideStickyBar'>
          <div className='settings-widget dash-profile'>
            <div className='settings-menu p-0'>
              <div className='profile-bg'>
                <h5 onClick={hideMobileMenu} style={{ cursor: 'pointer' }}></h5>
                <img src={InstructorProfileBg} alt='' />
                <div className='profile-img'>
                  <Link to='/instructor-profile'>
                    <img src={User15} alt='' />
                  </Link>
                </div>
              </div>
              <div className='profile-group'>
                <div className='profile-name text-center'>
                  <h4>
                    <Link to='/instructor-profile'>Admin</Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className='settings-widget account-settings feather-icon'>
            <div className='settings-menu'>
              <h3>DASHBOARD</h3>
              <ul>
                {/*}
              <li className="nav-item">
                {/*
                 <Link
                  to="/admin"
                  className={
                    activeMenu === "Dashboard" ? "nav-item active" : "nav-item"
                  }
                >
                  <Home size={20} /> My Dashboard
                </Link>
                <NavLink to="/admin" > 
                  <Home size={20} /> My Dashboard
                </NavLink>
              </li>
              <li className="nav-item" >
                <NavLink to="/admin/admin-student-grid"
                className={isActive(['/admin/admin-student-grid', '/admin/admin-studentedit','/admin/admin-studentdetail'])}>
                  <Users size={20} /> Students
                </NavLink>
              </li>
              */}
                <li className='nav-item'>
                  <NavLink to='/admin'>
                    <Users size={20} /> Students
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-instructor-list'>
                    <Sun size={20} /> Instructors
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-taskmanage'>
                    <Server size={20} /> Task Manager
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-counselorcorner/0/Admin'>
                    <Grid size={20} /> Private Note
                  </NavLink>
                </li>
              </ul>
              <div className='instructor-title'>
                <h3>SETTINGS</h3>
              </div>
              <ul>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-params'>
                    <Tool size={20} /> Parameters
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-booklist'>
                    <BookOpen size={20} /> BookList
                  </NavLink>
                </li>
                {/* <li className='nav-item'>
                  <NavLink to='/admin/admin-appcheck'>
                    <CheckCircle size={20} /> Application Check
                  </NavLink>
                </li> */}
                <li className='nav-item'>
                  <NavLink to='/admin/admin-class'>
                    <Folder size={20} /> Class
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-collegelistinfo'>
                    <Folder size={20} /> College List
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink to='/admin/admin-desiredcolleges'>
                    <User size={20} /> Desired Colleges
                  </NavLink>
                </li>
                {/* <li className='nav-item'>
                  <NavLink to='/admin/admin-lessons'>
                    <RefreshCw size={20} /> Lessons
                  </NavLink>
                </li> */}
                {/*}
              <li className="nav-item">
                <Link
                  to="/instructor-edit-profile"
                  className={
                    activeMenu === "EditProfile"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Settings size={20} /> Edit Profile
                </Link>
              </li>
              */}
                <li className='nav-item'>
                  <NavLink onClick={handleSignOut} className='nav-link'>
                    <Power size={20} /> Sign Out
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </StickyBox>
    </div>
  )
}
